export default "__VITE_ASSET__c65a94b1__"